import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddButtonComponent } from './add-button.component';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [AddButtonComponent],
  imports: [
    CommonModule,
    FeahterIconModule,
    NgbTooltipModule
  ],
  exports: [AddButtonComponent]
})
export class AddButtonModule { }
